module.exports = __webpack_public_path__ + "static/media/ODS4.1cdfbc13.jpeg";